import React, { Component, Fragment } from "react";
import _ from "lodash";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  DirectionsRenderer
} from "react-google-maps";
import AutoInput from "../containers/AutoInput";

const {
  SearchBox
} = require("react-google-maps/lib/components/places/SearchBox");
class MapForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      center: this.props.center,
      location: this.props.center,
      address: undefined,
      directions: this.props.directions
    };
  }

  componentWillMount() {
    this.google = window.google;
    this.refs = {};
    this.directionsService = new this.google.maps.DirectionsService();

    if (this.props.center.lat === null) {
      this.setState({
        center: MapForm.defaultProps.center,
        location: MapForm.defaultProps.center
      });
    }
  }

  componentDidMount() {
    if (this.locationIsValid()) {
      this.geocodeLatLng(this.state.location);

      if (!this.props.locate && this.state.directions) this.getDirection();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.center.lat !== this.props.center.lat ||
      prevProps.center.lng !== this.props.center.lng
    ) {
      this.setState(
        {
          center: this.props.center,
          location: this.props.center
        },
        () => {
          this.geocodeLatLng(this.props.center);
        }
      );
    }
  }

  getDirection() {
    const { origin, destination } = this.state.directions;

    this.directionsService.route(
      {
        origin,
        destination,
        travelMode: this.google.maps.TravelMode.DRIVING
      },
      (result, status) => {
        if (status === this.google.maps.DirectionsStatus.OK) {
          this.setState({
            directions: result
          });
        } else {
          console.error(`error fetching directions ${result}`);
        }
      }
    );
  }

  locationIsValid() {
    if (
      this.state.location.lat !== undefined &&
      this.state.location.lng !== undefined
    ) {
      return true;
    }

    return false;
  }

  onPlacesChanged() {
    const places = this.refs.searchBox.getPlaces();
    const firstPlace = _.first(places);
    const location = {
      lat: firstPlace.geometry.location.lat(),
      lng: firstPlace.geometry.location.lng()
    };

    this.geocodeLatLng(location);

    this.setState({
      center: location,
      location
    });
  }

  onDragEnd() {
    const position = this.refs.marker.getPosition();
    const location = {
      lat: position.lat(),
      lng: position.lng()
    };

    this.geocodeLatLng(location);
    this.setState({ location });
  }

  geocodeLatLng(latlng) {
    const { Geocoder } = this.google.maps;

    let geocoder = new Geocoder();

    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === "OK") {
        if (results[0]) {
          if (this.refs.input) {
            this.refs.input.value = results[0].formatted_address;
          }

          this.setState({
            address: results[0].formatted_address
          });
        } else {
          //
        }
      } else {
        //
      }
    });
  }

  renderSearchBox() {
    const { ControlPosition } = this.google.maps;

    return (
      <div>
        <SearchBox
          ref={ref => {
            this.refs.searchBox = ref;
          }}
          controlPosition={ControlPosition.TOP_CENTER}
          onPlacesChanged={() => {
            this.onPlacesChanged();
          }}
        >
          <input
            ref={ref => {
              this.refs.input = ref;
            }}
            type="text"
            placeholder="Search location"
            style={{
              boxSizing: "border-box",
              border: "1px solid transparent",
              width: "50%",
              height: "32px",
              marginTop: "10px",
              padding: "0 12px",
              borderRadius: "3px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
              fontSize: "14px",
              outline: "none",
              textOverflow: "ellipses"
            }}
          />
        </SearchBox>
        <Marker
          ref={ref => {
            this.refs.marker = ref;
          }}
          title={this.state.address}
          draggable={true}
          position={this.state.location}
          onDragEnd={() => {
            this.onDragEnd();
          }}
        />
      </div>
    );
  }

  render() {
    return (
      <Fragment>
        <GoogleMap
          ref={ref => {
            this.refs.map = ref;
          }}
          bootstrapURLKeys={{ key: "AIzaSyBzhd2gYGYfl0bdmCeLGrOjtwzcKcfYmF0" }}
          defaultZoom={this.props.zoom}
          center={this.state.center}
          options={{ scrollwheel: false }}
        >
          {this.props.locate ? (
            this.renderSearchBox()
          ) : (
            <DirectionsRenderer directions={this.state.directions} />
          )}
        </GoogleMap>
        {this.props.locate ? (
          <div>
            <AutoInput
              value={this.state.location.lat}
              form={this.props.form}
              model={"location"}
              attribute={"lat"}
              hidden
            />
            <AutoInput
              value={this.state.location.lng}
              form={this.props.form}
              model={"location"}
              attribute={"lng"}
              hidden
            />
            <AutoInput
              value={this.state.address}
              form={this.props.form}
              model={"location"}
              attribute={"address"}
              hidden
            />
          </div>
        ) : null}
      </Fragment>
    );
  }
}

MapForm.defaultProps = {
  center: {
    lat: 32.542832105911415,
    lng: -116.94411894708253
  },
  zoom: 15,
  locate: true
};

export default withScriptjs(withGoogleMap(MapForm));



// WEBPACK FOOTER //
// ./src/forms/MapForm.js